import React, { useState, useEffect } from "react";
import { initMercadoPago, Wallet } from "@mercadopago/sdk-react";
import axios from "axios";

initMercadoPago("APP_USR-79b5061f-9739-4b9e-b1d1-49038350489e", { locale: "es-AR" });

const PaymentButton = () => {
    const [preferenceId, setPreferenceId] = useState(null);

    useEffect(() => {
        axios.post("http://localhost:3001/api/create_preference")
            .then(response => {
                setPreferenceId(response.data.preferenceId);
            })
            .catch(error => {
                console.error("Error al obtener la preferencia:", error);
            });
    }, []);

    return (
        <div>
            {preferenceId ? (
                <Wallet initialization={{ preferenceId }} />
            ) : (
                <p>Cargando pago...</p>
            )}
        </div>
    );
};

export default PaymentButton;
